import { Platform } from 'react-native';
export class BaseAnalyticsDataSource {
    constructor(apiHTTPDataSource) {
        this.apiHTTPDataSource = apiHTTPDataSource;
        this.is_enabled = false;
        this.is_enabled_by_user = true;
    }
    setNextViewParams(data) {
        this.next_view_params = data;
    }
    setViewPath(path, params) {
        this.view_path = path;
        this.view_params = params;
    }
    setAppVersion(version) {
        this.app_version = version;
    }
    setIsEnabledByUser(value) {
        this.is_enabled_by_user = value;
        return this.is_enabled_by_user;
    }
    setIsEnabled(value) {
        this.is_enabled = value;
        return this.is_enabled;
    }
    sendInternalScreenEvent(data) {
        var _a, _b;
        return this.sendInternalEvent('screen_view', Object.assign(Object.assign({}, data), { resource_type: 'screen', resource_id: data.resource_id || ((_a = data === null || data === void 0 ? void 0 : data.view) === null || _a === void 0 ? void 0 : _a.screen_id) || ((_b = data === null || data === void 0 ? void 0 : data.view) === null || _b === void 0 ? void 0 : _b.id), view: Object.assign(Object.assign({}, this.next_view_params), data.view) }))
            .then(res => {
            this.setNextViewParams({});
            return res;
        });
    }
    sendInternalEvent(event, data) {
        var _a, _b, _c;
        const params = {
            path: 'resource_events',
            data: Object.assign(Object.assign({}, data), { title: undefined, resource_id: (data === null || data === void 0 ? void 0 : data.resource_id) || null, resource_type: (data === null || data === void 0 ? void 0 : data.resource_type) || 'default', path: (data === null || data === void 0 ? void 0 : data.path) || this.view_path || null, view: Object.assign(Object.assign(Object.assign({ screen_id: ((_a = this.view_params) === null || _a === void 0 ? void 0 : _a.id) || ((_b = data === null || data === void 0 ? void 0 : data.view) === null || _b === void 0 ? void 0 : _b.screen_id) || ((_c = data === null || data === void 0 ? void 0 : data.view) === null || _c === void 0 ? void 0 : _c.id) }, this.view_params), data === null || data === void 0 ? void 0 : data.view), { id: undefined }), payload: Object.assign(Object.assign({}, data === null || data === void 0 ? void 0 : data.payload), { os_type: Platform.OS, app_version: this.app_version || null }), event })
        };
        return this.apiHTTPDataSource.post(params)
            .catch(error => console.warn(error));
    }
}
